import { render, staticRenderFns } from "./VehiclesCard.vue?vue&type=template&id=506fe41e&"
import script from "./VehiclesCard.vue?vue&type=script&lang=js&"
export * from "./VehiclesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports